import html from '../lib/html-tagged-template-literal'
import styles from './client.css'
import { renderForklaringsscroll } from './components/forklaringsscroll.html'

export const rootClassName = styles.root

export function renderClient({
  props,
  staticHost,
  metadata,
  errorTrackingEnabled,
  catchServerUrl,
  gaPropertyId,
  useStegvisLottie
}) {
  return html`
    <dh-forklaringsscroll-app
      class="${rootClassName} ${rootClassName}--noJs"
      ${useStegvisLottie ? 'stegvis-lottie="true"' : ''}
      data-static-host="${staticHost}"
      data-metadata='${metadata}'
      data-error-tracking-enabled="${errorTrackingEnabled}"
      data-catch-server-url="${catchServerUrl}"
      data-ga-property-id="${gaPropertyId}"
    >
      ${renderForklaringsscroll(props)}
    </dh-forklaringsscroll-app>
  `
}
